(function () {
  var root = document.querySelector('.followswiss-cart');
  if (!root) return;

  var latestRequestId = 0;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'CHF ' + amount;
  }

  function updateSubtotal(totalPrice) {
    var subtotalEl = root.querySelector('[data-followswiss-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(totalPrice);
  }

  function sendChange(lineKey, quantity, requestId, badgeDelta) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart change failed');
        }
        return response.json();
      })
      .then(function (cart) {
        if (quantity === 0 || cart.item_count === 0) {
          window.location.reload();
          return;
        }

        // Ignore stale responses from older, superseded requests — the
        // line's own quantity/price is already correct from the optimistic
        // update, only the cart-wide badge/subtotal need the server value.
        if (requestId === latestRequestId) {
          window.followswissUpdateCartBadge(badgeDelta);
          updateSubtotal(cart.total_price);
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  root.querySelectorAll('[data-followswiss-qty-wrap]').forEach(function (wrap) {
    var lineKey = wrap.getAttribute('data-key');
    var unitPrice = parseInt(wrap.getAttribute('data-unit-price'), 10) || 0;
    var itemEl = wrap.closest('[data-followswiss-cart-line]');
    var valueEl = wrap.querySelector('[data-followswiss-qty-value]');
    var minusBtn = wrap.querySelector('[data-followswiss-qty-minus]');
    var plusBtn = wrap.querySelector('[data-followswiss-qty-plus]');
    var priceEl = itemEl ? itemEl.querySelector('[data-followswiss-line-price]') : null;
    var debounceTimer = null;
    var baseQty = parseInt(valueEl.textContent, 10) || 0;

    function applyOptimistic(next) {
      valueEl.textContent = next;
      if (priceEl && unitPrice) {
        priceEl.textContent = formatMoney(unitPrice * next);
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var delta = next - baseQty;
        baseQty = next;
        latestRequestId += 1;
        sendChange(lineKey, next, latestRequestId, delta);
      }, 350);
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var current = parseInt(valueEl.textContent, 10) || 1;
        var next = current - 1;
        if (next < 1) return;
        applyOptimistic(next);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var current = parseInt(valueEl.textContent, 10) || 1;
        applyOptimistic(current + 1);
      });
    }
  });

  root.querySelectorAll('[data-followswiss-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var lineKey = btn.getAttribute('data-key');
      var itemEl = btn.closest('[data-followswiss-cart-line]');
      var qtyValueEl = itemEl ? itemEl.querySelector('[data-followswiss-qty-value]') : null;
      var currentQty = qtyValueEl ? (parseInt(qtyValueEl.textContent, 10) || 0) : 0;
      if (itemEl) itemEl.style.opacity = '0.4';
      btn.disabled = true;
      latestRequestId += 1;
      sendChange(lineKey, 0, latestRequestId, -currentQty);
    });
  });
})();